<template>
  <div class="sets-with-product">
    <div class="sets-with-product__title-wrap">
      <div class="sets-with-product__title">
        {{ $t('product-sets__title') }}
        <span class="sets-with-product__title-count">{{ sliderData.length }}</span>
      </div>
      <div class="sets-with-product__navigation">
        <div class="swiper-button-prev sets-with-product__prev" slot="button-prev"></div>
        <div class="swiper-button-next sets-with-product__next" slot="button-next"></div>
      </div>
    </div>
    <swiper class="swiper sets-with-product__slider" :options="swiperOption" ref="swiper">
      <swiper-slide class="swiper-item" v-for="item in sliderData" :key="item.id">
        <div class="sets-with-product__item">
          <a :href="item.link" class="sets-with-product__item-img">
            <img :src="item.photos.image_url" alt="">
          </a>
          <div class="sets-with-product__item-info">
            <a :href="item.link" class="sets-with-product__item-title block-ellipsis block-ellipsis-truncate">{{ item.name }}</a>
            <div class="sets-with-product__item-action-wrap">
              <div class="sets-with-product__item-price-wrap">
                <div class="sets-with-product__item-price-old" v-if="item.price_old">{{ item.price_old | CurrencyFormatter }} грн</div>
                <div class="sets-with-product__item-price" :class="{'sets-with-product__item-price-new': item.price_old && item.price_new}">{{ item.price_new | CurrencyFormatter }} грн</div>
              </div>
              <BuyBtn
                :title-ru="item.name"
                :product-id="item.id"
                :code="item.code"
                :price="item.price_new"
                :product-link="item.link"
                :store-id="item.available_in_store && item.available_in_store.store_id ? item.available_in_store.store_id : ''"
                class="sets-with-product__item-buy-btn"
                type="icon-only"
              />
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import BuyBtn from '@/components/cart/BuyBtn.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { isTouch } from '@/mixins/isTouchDevice'
import CurrencyFormatter from '@/filters/CurrencyFormatter'

export default {
  name: 'SetsWithProductNew',
  components: { SwiperSlide, BuyBtn, Swiper },
  data () {
    return {
      swiperOption: {
        autoHeight: true,
        watchSlidesVisibility: true,
        spaceBetween: 0,
        slidesPerView: 1.1,
        navigation: {
          nextEl: '.sets-with-product__next',
          prevEl: '.sets-with-product__prev'
        },
        simulateTouch: !isTouch,
        touchStartPreventDefault: false,
        breakpoints: {
          1100: {
            slidesPerView: 2
          }
        }
      }
    }
  },
  props: {
    productId: {
      type: Number,
      required: true
    },
    setsWithProduct: {
      type: Array,
      required: true
    }
  },
  computed: {
    sliderData () {
      if (this.setsWithProduct.length) {
        return this.setsWithProduct
      }
      return []
    }
  },
  filters: {
    CurrencyFormatter
  }
}
</script>

<style lang="sass">
.sets-with-product
  &__item
    &-buy-btn
      .buy-btn
        padding: 11px
        max-height: 44px
  &__slider
    .swiper-wrapper
      align-items: stretch
</style>
<style lang="sass" scoped>
@import "~swiper/css/swiper.min.css"
@import "../../../styles/swiper/swiper"
.sets-with-product
  margin-top: 40px
  +mmin($tablet)
    order: 1
  &__navigation
    position: relative
    width: 65px
    height: 30px
    margin-left: auto
    display: none
    +mmin($tablet)
      display: block
  &__title
    font-size: 18px
    font-weight: 500
    line-height: 1.2
    color: #333
    span
      color: #CCCCCC
      padding-left: 10px
    &-wrap
      display: flex
      align-items: center
      margin-bottom: 15px
  &__item
    border: 1px solid #EDEDED
    //border-right: none
    display: flex
    align-items: flex-start
    width: 100%
    height: 100%
    box-sizing: border-box
    //&:last-child
    //  border-right: 1px solid #EDEDED
    &-img
      width: 100px
      height: 100px
      position: relative
      margin: 5px 10px
      flex-shrink: 0
      img
        position: absolute
        left: 50%
        top: 50%
        transform: translate(-50%, -50%)
        max-height: 100%
    &-info
      width: calc(100% - 120px)
      flex-shrink: 0
      padding: 13px 16px 11px 0
      height: 100%
      display: flex
      flex-direction: column
    &-title
      font-size: 14px
      line-height: 1.2
      color: #333
      text-decoration: none
      margin-bottom: auto
      width: 100%
      display: block
      -webkit-box-orient: vertical
      -webkit-line-clamp: 3
      max-height: 50px
      display: -webkit-box
    &-action-wrap
      margin-top: 11px
      display: flex
      align-items: center
      justify-content: space-between
    &-price
      font-size: 16px
      line-height: 24px
      font-weight: 500
      &-old
        font-size: 14px
        color: #909090
        line-height: 1.2
        text-decoration: line-through
        text-decoration-color: #FF2F00
        font-weight: 400
      &-new
        color: #FF2F00
        font-weight: 500
</style>
